import React, {useContext, useEffect, useRef, useState} from 'react';
import FacilityIcon from '../../../assests/img/facility.svg?react';
import DropdownIcon from '../../../assests/img/dropdown.svg?react';
import CorrectIcon from '../../../assests/img/correct.svg?react';
import {getColor} from '../functions/getColor';
import {filterData} from './DropdownFilter';
import {FilterContext} from '../context/filterContext';
import classNames from 'classnames';
import {isFilterSelected} from '../functions/filter';
import ShieldIcon from '../../../assests/img/sheild.svg?url';

export interface cardCoverageFacilityProps {
    coverage: filterData,
    facilityTypes: filterData[],
    view: 'brief' | 'detail',
    edit: boolean,
    onUpdate?: (id: number, value: string,
        field: coverageFacility, logo: string)=> Promise<void>,
}

export enum coverageFacility {
    'coverage', 'facility'
}

export default function CardCoverageFacility(props: cardCoverageFacilityProps) {

    const {coverage, facilityTypes, view, edit, onUpdate} = props;
    const {filterData} = useContext(FilterContext);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const facilityRef = useRef<HTMLDivElement>(null);
    const [showSelect, setShowSelect] = useState(false);
    const [facilitySelect, setFacilitySelect] = useState(false);
    const [coverageLoading, setCoverageLoading] = useState(false);
    const [facilityLoading, setFacilityLoading] = useState(false);

    const handleClickOutside=(event: MouseEvent)=> {
        if (dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)) {
            setShowSelect(false);
        }
        if (facilityRef.current &&
            !facilityRef.current.contains(event.target as Node)) {
                setFacilitySelect(false);
            }
    }

    const handleShowSelect = () => {
        if (showSelect) {
            setShowSelect(false);
        } else {
            setShowSelect(true);
        }
    }

    const handleCoverageSelect = async (id: number, value: string,
        logo: string) => {
        setCoverageLoading(true);
        setShowSelect(false);
        if (onUpdate) {
            await onUpdate(id, value, coverageFacility.coverage, logo);
        }
        setCoverageLoading(false);
    }

    const handleFacilitySelect = async (id: number, value: string,
        logo: string) => {
        setFacilityLoading(true);
        setFacilitySelect(false);
        if (onUpdate) {
            await onUpdate(id, value, coverageFacility.facility, logo);
        }
        setFacilityLoading(false);
    }

    const renderCoverage = (name: string, logo: string | undefined) => {
        return (
            <span className="coverage-name-icon-container">
                <span>
                    <img src ={logo? logo: ShieldIcon}
                        width={'15px'}/>
                </span>
                <span className="card-coverage-name">
                    {name.length === 0?
                        'Coverage': name}
                </span>
            </span>
        );
    }

    useEffect(()=> {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [
    ]);


    return (
        <div className="card-deails-container">
            <div className="card-details">
                <div className={classNames(
                    'card-line-type', edit? 'edit-line-type': '')}
                    onClick={handleShowSelect}>
                    <span>
                        {edit?
                            <div className="line-type-dropdown"
                             onClick={handleShowSelect}>
                            {renderCoverage(coverage.value, coverage.logo)}
                            {coverageLoading? <span className="edit-loader"/>: <DropdownIcon/>}
                            </div>: renderCoverage(coverage.value,
                                coverage.logo)
                        }
                         {showSelect && edit?
                            <div className="coverage-options-container" ref={dropdownRef}>
                                <span className="coverage-option-items">
                                        {filterData.coverage.slice(1).map(({id,
                                            value, logo})=> {
                                            return (
                                                <span key={`coverage-${id}-select`} className="coverage-option-item"
                                                    onClick={()=>
                                                        handleCoverageSelect(id,
                                                            value, logo? logo: '')}>
                                                        {value}
                                                </span>
                                            );
                                        })}  
                                </span>
                            </div>: null}
                    </span>
                </div>
                <div className={classNames('card-coverage-types' ,'float-right',
                        'facility-types-detail',
                        edit? 'edit-line-type': '')} onClick={()=>
                            setFacilitySelect(true)}>
                    <span>
                        <FacilityIcon width={"24"} height={"24"}/>
                    </span>
                    {facilityTypes.slice(0, view === 'brief'? 3: facilityTypes.length).map(({id, value})=> {
                        return (
                            id !== 0?
                            <span key={`brief-${value}-${id}`}
                            className="card-coverage-name-container" style={{
                                backgroundColor: getColor(id)}}>
                                    <span className="card-coverage-name">{value}</span>
                            </span>:  <span className="card-coverage-name">
                                Facility</span>
                        );
                    })}
                    {edit? facilityLoading?
                        <span className="edit-loader"/>: <DropdownIcon/>: null}
                    {facilitySelect && edit?
                             <div className="coverage-options-container" ref={facilityRef}>
                                 <span className="coverage-option-items">
                                        {filterData.facilityType.slice(1)
                                        .map(({id, value})=> {
                                            return (
                                                <span key={`$facility-${id}-select`}
                                                    className="coverage-option-item
                                                    facility-option-item"
                                                    onClick={()=>
                                                        handleFacilitySelect(id,
                                                            value, '')}>
                                                        <span>{value}</span>
                                                        {isFilterSelected(id,
                                                            facilityTypes)?
                                                        <CorrectIcon width={14}
                                                            height={14}/>: null}
                                                        
                                                </span>
                                            );
                                        })}  
                                 </span>
                    </div>: null}
                    {view === 'brief'? facilityTypes.length > 3?
                    <span className="card-coverage-name-container facility-type">
                        <span className="card-coverage-name">+{facilityTypes.length-3}</span>
                    </span>: null: null}
                </div> 
            </div>
        </div>
    );

}